import React, { useState } from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { ControlPosition } from 'leaflet';
import { useLang } from '~/hooks/useLang';
import satellite from './images/satellite.png';
import relevo from './images/relevo.png';
import traffic from './images/traffic.png';
import LayersIcon from '@mui/icons-material/Layers';

interface ILayerTileControl {
  readonly position: ControlPosition;
  readonly onChangeTile: (value: string) => void;
  readonly tileName?: string;
  readonly darkMode?: boolean;
}

const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
}

// eslint-disable-next-line max-lines-per-function
export default function LayerTileControl({ position, onChangeTile, tileName }: ILayerTileControl) {
  const { translate } = useLang();
  const [openLayerChange, setOpenLayerChange] = useState<boolean>(false);
  const positionClass = POSITION_CLASSES[position];

  return (
    <div className={positionClass}>
      <div
        className="leaflet-control leaflet-bar"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          padding: 4,
          height: '80px',
          border: 'none',
          marginBottom: '3px',
        }}>
        <Button
          sx={{ height: '64px' }}
          variant={'contained'}
          onClick={() => setOpenLayerChange(!openLayerChange)}
        >
          <LayersIcon />
        </Button>
        {openLayerChange ? (
          <Stack
            direction={'row'}
            spacing={1}
            sx={{
              width: '250px',
              backgroundColor: '#fff',
              justifyContent: "space-between",
              alignItems: "stretch",
              borderRadius: 2,
            }}
          >
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: 'transparent',
                backgroundColor: '#fff',
                '&:hover': {
                  border: '1px solid',
                  borderColor: 'primary.main',
                }
              }}
            >
              <Button
                variant={'outlined'}
                sx={{
                  border: 'none',
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none'
                  }
                }}
                onClick={() => {
                  onChangeTile('mapbox/streets-v12');
                  setOpenLayerChange(false);
                }}>
                <img
                  src={relevo}
                  width={50}
                  height={40}
                  style={{
                    borderRadius: '4px',
                    objectFit: 'cover',
                    border: '2px solid',
                    borderColor: tileName === 'mapbox/streets-v12' ? 'primary.main' : 'transparent'
                  }}
                />
              </Button>
              <Typography sx={{ color: '#000' }}>
                {translate('Relief')}
              </Typography>
            </Paper>
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: 'transparent',
                backgroundColor: '#fff',
                '&:hover': {
                  border: '1px solid',
                  borderColor: 'primary.main',
                }
              }}>
              <Button
                variant={'outlined'}
                sx={{
                  border: 'none',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none'
                  }
                }}
                onClick={() => {
                  onChangeTile('mapbox/satellite-streets-v12');
                  setOpenLayerChange(false);
                }}>
                <img
                  src={satellite}
                  width={50}
                  height={40}
                  style={{
                    borderRadius: '4px',
                    objectFit: 'cover',
                    border: '2px solid',
                    borderColor: tileName === 'mapbox/satellite-streets-v12' ? 'primary.main' : 'transparent'
                  }}
                />
              </Button>
              <Typography sx={{ color: '#000' }}>
                {translate('Satellite')}
              </Typography>
            </Paper>
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: 'transparent',
                backgroundColor: '#fff',
                '&:hover': {
                  border: '1px solid',
                  borderColor: 'primary.main',
                }
              }}>
              <Button
                variant={'outlined'}
                sx={{
                  border: 'none',
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none'
                  }
                }}
                onClick={() => {
                  onChangeTile('mapbox/navigation-day-v1');
                  setOpenLayerChange(false);
                }}>
                <img
                  src={traffic}
                  width={50}
                  height={40}
                  style={{
                    borderRadius: '4px',
                    objectFit: 'cover',
                    border: '2px solid',
                    borderColor: tileName === 'mapbox/navigation-day-v1' ? 'primary.main' : 'transparent'
                  }} />
              </Button>
              <Typography sx={{ color: '#000' }}>
                {translate('Traffic')}
              </Typography>
            </Paper>
          </Stack>

        ) : (
          false
        )}

      </div>
    </div>
  );
}
